export enum AppPages {
  HomePage = "/",
  SuccessfulRequest = "/successful-request",
  Exceeded = "/exceeded",
  NotFoundPage = "*",
  LoginCallback = "/login/callback",
  ConfirmPublicTest = "/confirm",
}
